// extracted by mini-css-extract-plugin
export default {"container":"fp-avg_container__ugt2P","body":"fp-avg_body__CpZSS","value":"fp-avg_value__Z440A","progressbar":"fp-avg_progressbar__qKUEm"};